import { Injectable } from "@angular/core";
import { type AbstractControl, FormControl, type FormGroup, FormBuilder, Validators } from "@angular/forms";
import type { StringOrNull } from "@core-interfaces/global";

export interface IRecoverEmailFormInput {
    email: FormControl<StringOrNull>;
}

export interface IRecoverCodeFormInput {
    code: FormControl<StringOrNull>;
}

export interface IRecoverNewPasswordFormInput {
    new_password: FormControl<StringOrNull>;
    confirm_password: FormControl<StringOrNull>;
}

function passwordsMatchValidator(form: AbstractControl): { passwordsMismatch: true } | null {
    const group = form as FormGroup;
    const newPwd = group.get('new_password')?.value;
    const confirm = group.get('confirm_password')?.value;
    if (confirm && newPwd !== confirm) {
        group.get('confirm_password')?.setErrors({ passwordsMismatch: true });
        return { passwordsMismatch: true };
    }
    const existing = group.get('confirm_password')?.errors;
    if (existing?.['passwordsMismatch']) {
        group.get('confirm_password')?.setErrors(null);
    }
    return null;
}

@Injectable({ providedIn: 'root' })
export class RecoverPasswordFormFactory {

    constructor(private fb: FormBuilder) {}

    generateEmailForm(): FormGroup<IRecoverEmailFormInput> {
        return this.fb.group<IRecoverEmailFormInput>({
            email: new FormControl<StringOrNull>(null, [Validators.required, Validators.email]),
        });
    }

    generateCodeForm(): FormGroup<IRecoverCodeFormInput> {
        return this.fb.group<IRecoverCodeFormInput>({
            code: new FormControl<StringOrNull>(null, [Validators.required, Validators.pattern(/^\d{6}$/)]),
        });
    }

    generateNewPasswordForm(): FormGroup<IRecoverNewPasswordFormInput> {
        return this.fb.group<IRecoverNewPasswordFormInput>({
            new_password: new FormControl<StringOrNull>(null, [Validators.required, Validators.minLength(8)]),
            confirm_password: new FormControl<StringOrNull>(null, [Validators.required]),
        }, { validators: passwordsMatchValidator });
    }
}
